import Vue from 'vue';
import moment from 'moment-timezone';
import types from '../mutations/mutation-types';
import api from '../../utils/api';
import { getUser } from '../../utils/auth';

export default {
  state: {
    agentSessions: [],
    generalSessions: []
  },
  mutations: {
    [types.SESSIONS.POPULATE_SESSIONS](state, details) {
      state[details.type] = details.sessions;
    },
    [types.SESSIONS.MODIFY_SESSION](state, details) {
      if (details.reorder) {
        Vue.delete(state[details.sessionType], details.index);
        state[details.sessionType] = [details.session, ...state[details.sessionType]];
      } else {
        Vue.set(state[details.sessionType], details.index, details.session);
      }
    },
    [types.SESSIONS.REMOVE_SESSION](state, details) {
      Vue.delete(state[details.sessionType], details.index);
    },
    [types.SESSIONS.ADD_SESSION](state, details) {
      const newSessions = Array.isArray(details.session) ? details.session : [details.session];
      state[details.sessionType] = [...state[details.sessionType], ...newSessions];
    }
  },
  actions: {
    loadActiveSessions({ commit }, paramFilter) {
      return new Promise((resolve) => {
        api.buildRequest('active-users', 'POST', null, paramFilter || {})
          .then(({ status, data }) => {
            if (status === 200 && data.payload) {
              const allChats = {
                generalChats: [],
                agentChats: []
              };
              data.payload.forEach(({ owner, lastAppResponse, lastUserResponse, accountid,
                keyword, usertype }) => {
                const agent = getUser().nickname;
                // show only chats without owners (general chats) or chats belonging to users
                if (!owner || (owner && owner === agent)) {
                  if ((lastAppResponse && lastAppResponse > lastUserResponse) ||
                    !lastUserResponse) {
                    // if message has been read then append it to the array
                    allChats[owner === agent ? 'agentChats' : 'generalChats'].push({
                      user: accountid,
                      new: false,
                      time: '',
                      keyword,
                      usertype
                    });
                  } else {
                    // if message has not been read, then prepend it to the array
                    allChats[owner === agent ? 'agentChats' : 'generalChats'].splice(0, 0, {
                      user: accountid,
                      new: true,
                      time: moment.unix(lastUserResponse).tz('Africa/Nairobi').format('DD-MM-YYYY HH:mm'),
                      keyword,
                      usertype
                    });
                  }
                }
              });
              commit(types.SESSIONS.POPULATE_SESSIONS, {
                type: 'agentSessions',
                sessions: allChats.agentChats
              });
              commit(types.SESSIONS.POPULATE_SESSIONS, {
                type: 'generalSessions',
                sessions: allChats.generalChats
              });
            }
            resolve();
          });
      });
    },
    setActiveChat({ getters, commit, state }, { phoneNumber, type, typeOfSession, chatIndex }) {
      let sessionType = typeOfSession;
      let index = chatIndex;
      if (index === -1) {
        if (sessionType) {
          index = getters.getChatIndex(phoneNumber, sessionType);
        } else {
          ({ index, sessionType } = getters.getChatSessionType(phoneNumber));
        }
      }
      if (index >= 0) {
        commit(types.SESSIONS.MODIFY_SESSION, {
          index,
          sessionType,
          session: { ...state[sessionType][index], current: type }
        });
      }
    },
    newChatSessionMessage({ commit, state }, { index, sessionType, update }) {
      commit(types.SESSIONS.MODIFY_SESSION, {
        index,
        sessionType,
        reorder: true,
        session: { ...state[sessionType][index], ...update }
      });
    },
    endChatSession({ commit }, chatDetails) {
      if (chatDetails.sessionType) {
        commit(types.SESSIONS.REMOVE_SESSION, chatDetails);
      }
    },
    markChatRead({ commit, state, getters }, phoneNumber) {
      const { index, sessionType } = getters.getChatSessionType(phoneNumber);
      if (sessionType) {
        commit(types.SESSIONS.MODIFY_SESSION, {
          index,
          sessionType,
          session: { ...state[sessionType][index], new: false, time: null }
        });
      }
    },
    claimChats({ commit, state, getters, dispatch }, { accountids, agent, currentAgent }) {
      const claimedSessions = [];
      accountids.forEach((phoneNumber) => {
        const index = getters.getChatIndex(phoneNumber, 'generalSessions');
        if (agent === currentAgent) {
          claimedSessions.push(state.generalSessions[index]);
        }
        commit(types.SESSIONS.REMOVE_SESSION, {
          sessionType: 'generalSessions',
          index
        });
      });
      if (claimedSessions.length) {
        dispatch('addNewChatSessions', {
          sessionType: 'agentSessions',
          session: claimedSessions
        });
      }
    },
    addNewChatSessions({ commit }, { sessionType, session }) {
      commit(types.SESSIONS.ADD_SESSION, {
        sessionType,
        session
      });
    },
    performClaimOrRelease(context, { url, accountids, agent }) {
      return api.buildRequest(url, 'POST', null, {
        accountids,
        agent
      });
    },
    filterActiveSessions({ commit }, newSessions) {
      commit(types.SESSIONS.POPULATE_SESSIONS, {
        type: 'generalSessions',
        sessions: newSessions
      });
    }
  },
  getters: {
    getChatSessionType: (state, getters) => (phoneNumber) => {
      let index = getters.getChatIndex(phoneNumber, 'agentSessions');
      if (index >= 0) {
        return { index, sessionType: 'agentSessions' };
      }
      index = getters.getChatIndex(phoneNumber, 'generalSessions');
      if (index >= 0) {
        return { index, sessionType: 'generalSessions' };
      }
      return { index: -1, sessionType: '' };
    },
    /**
     * @function getChatIndex
     * @description check if the phone number is in the list of active sessions
     * @param {string} phoneNumber phone to search for
     * @param {string} sessionType the type of session the user belongs to (personal or general)
     * @returns {number} the index or -1 if not found
     */
    getChatIndex: state => (phoneNumber, type) =>
      state[type].findIndex(chat => chat && chat.user === phoneNumber)
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/session.js